import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { ConceptoPagoRealizadoEdit } from "./edit";
const EditModal = ConceptoPagoRealizadoEdit;
type Entity = models.ConceptoPagoRealizado;
export interface Props {
    value: Entity[];
    onChange: (value: Entity[]) => PromiseLike<void>;
    readonly?: boolean;
    error?: kea.FieldError;
    total: number;
    faltan: number;
}

/**Obtiene las columnas del grid */
function columnas(deps: kea.BotonesListaDeps<Entity>): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [
        botones,
        { title: "Forma de pago", cell: x => ({ data: models.FormaPagoMovimientoCaja[x.FormaPago] }) },
        { title: "Monto", cell: x => ({ data: x.Monto, string: kea.formatCurrency(x.Monto) }) },
        { title: "Ult. digitos cuenta", cell: x => ({ data: x.UltDigitosCuenta }) },
    ];
}

/**
* Listado de ConceptoPagoRealizado
*/
class ConceptoPagoRealizadoListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();
    private handleOnAgregar = async () => {
        const result = await this.modals.showModal(EditModal, {total: this.props.total, faltan: this.props.faltan}, {} as Entity);;
        if (result.result) {
            const newItem = result.value;
            const oldList = this.props.value;
            await this.props.onChange([...oldList, newItem]);
        }
    }

    private handleOnEditar = async (item: Entity) => {
        const result = await this.modals.showModal(EditModal, {total: this.props.total, faltan: this.props.faltan}, item);
        if (result.result) {
            const newItem = result.value;
            const oldList = this.props.value;
            await this.props.onChange(oldList.map(x => x == item ? newItem : x));
        }
    }

    private handleOnBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?", kea.formatCurrency(item.Monto));
        if (ok) {
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    render() {
        const cols = columnas({ onBorrar: this.handleOnBorrar, onEdit: this.handleOnEditar });
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <kea.Title size="h4" titulo="Conceptos de pago" error={this.props.error} >
                                <kea.AgregarButton onClick={this.handleOnAgregar} disabled={this.props.readonly} />
                        </kea.Title>
                    </div>
                </div>

                <kea.Grid2 items={this.props.value} columnas={cols} hideBusqueda />
                {this.modals.component}
            </div>
        );
    }
}
export const ConceptoPagoRealizadoList = kea.mapProps(componentToRx(ConceptoPagoRealizadoListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/pago/views/desglose/conceptos/list.tsx